import { render } from "./EventList.vue?vue&type=template&id=8e3a4aaa&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=8e3a4aaa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8e3a4aaa"

export default script